import { pluralized } from "common/utils/strings";

import { DosageReminder } from "../types";
import { INTERVAL_LABEL_DISPLAY, PATIENT_CHIP_VARIANTS } from "../constants";

export const getFrequencyLabel = ({ frequency, interval_unit: intervalUnit }: DosageReminder) => {
  if (frequency === 1) {
    return INTERVAL_LABEL_DISPLAY[intervalUnit];
  }
  return `Every ${frequency} ${pluralized(frequency, intervalUnit.toLowerCase())}`;
};

type GetChipVariantByPatientIdParams = {
  reminders: DosageReminder[];
  otherPatientIds?: number[];
};

/**
 * Cycles chip colors across patients in order of their first reminder, then across any
 * otherPatientIds without reminders, so each patient keeps the same color wherever it's shown
 */
export const getChipVariantByPatientId = ({
  reminders,
  otherPatientIds = [],
}: GetChipVariantByPatientIdParams) => {
  const patientIds = new Set([
    ...[...reminders].sort((a, b) => a.id - b.id).map((reminder) => reminder.patient.id),
    ...otherPatientIds,
  ]);

  return new Map(
    [...patientIds].map((patientId, index) => [
      patientId,
      PATIENT_CHIP_VARIANTS[index % PATIENT_CHIP_VARIANTS.length],
    ]),
  );
};
